import React, { useState, useEffect, useRef, useDebugValue } from "react";
import {
  getDeviceList,
  updateDeviceList,
  addDeviceList,
  changeCustomerPlanAndClearDevices
} from "../services/apiServices";
import {
  Box,
  Typography,
  List,
  ListItem,
  Button,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
} from "@mui/material";

import { getQueryParam} from "../utils/utils";
import { PRODUCT_CODES} from "../assets/const/constant"
import { getSelfcareUrl } from "../config/config";

import GetUserOnline from "../components/GetUserOnline";
import { ETHERNET_PLAN_TYPE } from "../assets/const/constant";
import { HomeRouterModal } from "./HomeRouterModal";
import { getAccountEntitlementsSelfcareUrl } from "../utils/accountEntitlementsUtils";
import { useParams } from "react-router-dom";

const DeviceModelSelector = ({ onDeviceAdd }) => {
  const [deviceModel, setDeviceModel] = useState("");
  const [deviceName, setDeviceName] = useState("");
  const [macAddress, setMacAddress] = useState(getQueryParam("mac") || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log(
      "device model",
      deviceModel,
      "device name",
      deviceName,
      "MAC",
      macAddress
    );
    onDeviceAdd({
      model: deviceModel,
      name: deviceName,
      mac: macAddress,
    });
  };

  return (
    <Box component="form" onSubmit={handleSubmit}>
      <Typography variant="h6" sx={{ mb: 3 }}>
        Add a new device
      </Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <InputLabel>Device Type</InputLabel>
        <Select
          value={deviceModel}
          label="Device Type"
          onChange={(e) => setDeviceModel(e.target.value)}
          required
          sx={{ textAlign: "left" }}
        >
          <MenuItem value="Smart Phone">
            <span className="deviceModel Smart Phone"></span>Phone
          </MenuItem>
          <MenuItem value="Tablet">
            <span className="deviceModel Tablet"></span>Tablet
          </MenuItem>
          <MenuItem value="Computer">
            <span className="deviceModel Computer"></span>Computer
          </MenuItem>
          <MenuItem value="Gaming">
            <span className="deviceModel Gaming"></span>Game Console
          </MenuItem>
          <MenuItem value="TV">
            <span className="deviceModel TV"></span>TV
          </MenuItem>
          <MenuItem value="Smart Device">
            <span className="deviceModel Device"></span>Other
          </MenuItem>
        </Select>
      </FormControl>
      <TextField
        fullWidth
        label="Device Name"
        value={deviceName}
        onChange={(e) => setDeviceName(e.target.value)}
        required
        sx={{ mb: 2 }}
      />
      <Button
        type="submit"
        variant="contained"
        sx={{ 
          fontSize: "16px", 
          boxShadow: "none", 
          mt: 3, 
          backgroundColor: 'rgb(212,43,30) !important',
          "&:hover": {
            opacity: "80%",
          },
         }}
      >
        Add Device
      </Button>
    </Box>
  );
};

const UpdateResponseModal = ({ handleUpdateSuccessContinueLoginFlow}) => {
  return (
    <Box sx={{ textAlign: "center" }} data-test-id="update-success-modal">
      <Typography
        variant="h6"
        sx={{ mb: 3, textAlign: "center" }}
        data-test-id="update-success-title"
      >
        Success!
      </Typography>
      <Typography variant="body1" sx={{ mb: 4, textAlign: "center" }}>
        Click Continue to finish the login process
      </Typography>
      <Button
        onClick={handleUpdateSuccessContinueLoginFlow}
        fullWidth
              variant="contained"
              color="primary"
                sx={{
                  boxShadow: "none",
                  height: "50px",
                  paddingX: 8,
                  mt: 3,
                  backgroundColor: 'rgb(212,43,30) !important',
                  "&:hover": {
                    backgroundColor: 'rgba(212,43,30, .8) !important',
                  },
                }}
        data-test-id="update-success-modal-continue"
      >
        Continue
      </Button>
    </Box>
  )
}

const UpgradeModal = ({ finishLogin, handleUpdateCustomer }) => {
  return (<Box  sx={{ textAlign: "center" }} data-test-id="upgrade-modal">
      <Typography
        variant="h6"
        sx={{ mb: 3, top: "50%", textAlign: "center" }}
        data-test-id="upgrade-modal-title"
      >
      We've noticed you're on a different base!
      </Typography>  
      <Typography variant="body1" sx={{ mb: 2, textAlign: "center" }}>
        If you've moved, you'll need to change your plan for the best experience. <br />
        Your new plan will be Boingo Fiber with speeds up to 1 Gbps for $69/month.
      </Typography>
      <Button
        onClick={handleUpdateCustomer}
        fullWidth
              variant="contained"
              color="primary"
              disableElevation
              sx={{
                mt: 1,
                mb: 2,
                paddingY: 0.5,
                color: "#fff",
                position: "relative",
                height: "50px",
                "&.Mui-disabled": {
                  backgroundColor: "#ccc",
                  color: "#666",
                },
                fontSize: "1rem"
              }}
        data-test-id="upgrade-modal-upgrade"
      >
        I've Moved - Change My Plan
      </Button>      
    </Box>
    )
}

const GoToSelfcare = ({ finishLogin }) => {
  const { venueId } = useParams();

  const handleSelfcareClick = () => {
    if (getAccountEntitlementsSelfcareUrl !== undefined && venueId) {
        window.location.href = getAccountEntitlementsSelfcareUrl(venueId) 
    } else if (getSelfcareUrl !== undefined && venueId)  {
      window.location.href = getSelfcareUrl(window.location.hostname) + `?from=${venueId.toLowerCase()}`;
    } else {
      window.location.href = "my.boingohotspot.net/login";
    }
  }

  return (
    <Box sx={{ textAlign: "center" }} data-test-id="upgrade-modal">
      <Typography
        variant="h6"
        sx={{ mb: 3, top: "50%", textAlign: "center" }}
        data-test-id="upgrade-modal-title"
      >
        We've noticed you're on a different base!
      </Typography>
      <Typography variant="body1" sx={{ mb: 2, textAlign: "center" }}>
        If you've moved, we offer several great plans to keep you connected.
        Simply log in, change your plan, then disconnect and reconnect to the
        Boingo network to get online.
      </Typography>
      <Button
        onClick={handleSelfcareClick}
        fullWidth
        variant="contained"
        color="primary"
        disableElevation
        sx={{
          mt: 1,
          mb: 2,
          paddingY: 0.5,
          color: "#fff",
          position: "relative",
          height: "50px",
          "&.Mui-disabled": {
            backgroundColor: "#ccc",
            color: "#666",
          },
          fontSize: "1rem",
        }}
        data-test-id="upgrade-modal-upgrade"
      >
        Selfcare
      </Button>
    </Box>
  );
}

export const DeviceIDFlow = ({ 
  loginData, 
  onSuccess, 
  onError, 
  closeModal, 
  setShowDeviceIDFlow
}) => {
  const [deviceList, setDeviceList] = useState([]);
  const [selectedDevice, setSelectedDevice] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [routerError, setRouterError] = useState(null);
  const [showGetUserOnline, setShowGetUserOnline] = useState(false);
  const [showDeviceModelSelector, setShowDeviceModelSelector] = useState(false);
  const [showHomeRouterModal, setShowHomeRouterModal] = useState(false);
  const [modalText, setModalText] = useState("Select the device you would like to replace");
  const [macAddress, setMacAddress] = useState(getQueryParam("mac") || "");
  const [homeRouter, setHomeRouter] = useState(null);
  const [deviceMac,] = useState(getQueryParam("mac") || "");
  const [showUpdate, setShowUpdate] = useState(false);
  const [showUpdateResponse, setShowUpdateResponse] = useState(false);
  const [showSelfcare, setShowSelfcare] = useState(false);
  const [deviceListResponseData, setDeviceListResponseData] = useState(null);
  const [updateResponse, setUpdateResponse] = useState(null);
  
  const { venueId } = useParams();
  const fetchedRef = useRef(false);

  const onClose = () => {
    closeModal();
  };

  
  const handleUpdateCustomer = async () => {
    try {
      const response = await changeCustomerPlanAndClearDevices({"product_codes": [
        PRODUCT_CODES.ethernet
      ]})
      setShowUpdate(false);
      setShowUpdateResponse(true);
      fetchedRef.current = false; // so we can refresh the device list;
      setUpdateResponse(response);
      
    }
    catch (error){
      const message = ``;
      onError(
        message,
        true,
        <>
          Failed to update product. Please visit{" "}
          <a
            href={
              getAccountEntitlementsSelfcareUrl !== undefined && venueId
                ? getAccountEntitlementsSelfcareUrl(venueId)
                : getSelfcareUrl(window.location.hostname)
            }
          >
            {" "}
            Selfcare{" "}
          </a>
        </>
      );
    }
    
  }

  const fetchDeviceListResponseHelper = (response) => {
    if (response?.data?.planType && response?.data?.planType === ETHERNET_PLAN_TYPE) {
          const homeRouter = response?.data?.routerDevices?.[0] || null;
          // if no home router, make oldest device Home Router
          if (!homeRouter) {
            const earliestTimestamp = Math.min(...response?.data?.devices?.map(item => new Date(item.created_date).getTime()));
            const newHomeRouter = response?.data?.devices?.find(item => new Date(item.created_date).getTime() === earliestTimestamp);
            setHomeRouter({...newHomeRouter, name: "Home Router"});
          } else {
            setHomeRouter(homeRouter);
          }
  
          const withoutHomeRouterList = response?.data?.devices?.filter(item => item.name !== "Home Router") || '';
          withoutHomeRouterList?.length && setDeviceList(withoutHomeRouterList);
          setShowHomeRouterModal(true);
    } else {
      setDeviceList(response.data.devices);
    }
    setShowUpdate(false);
    setShowUpdateResponse(false);
    setIsLoading(false);
  }

  const handleUpdateSuccessContinueLoginFlow = async () => {
    const response = deviceListResponseData;
    if (response !== null){
      fetchDeviceListResponseHelper(response);
    }
  }


  const handleFinishLogin = async () => {
    const response = deviceListResponseData;
    if (response !== null){
      fetchDeviceListResponseHelper(response);
    }
  }

  const fetchDeviceList = async () => {
    if (fetchedRef.current) return; // If already fetched, don't fetch again
    fetchedRef.current = true; // Mark as fetched

    try {
      setIsLoading(true);
      const response = await getDeviceList(loginData);
      setDeviceListResponseData(response);
      if (response?.data?.planType && response?.data?.planType !== ETHERNET_PLAN_TYPE){
        if (response.data?.hasToken){
          setShowUpdate(true)
          setIsLoading(false);
        }
        else {
          setShowSelfcare(true);
          setIsLoading(false);
        }
      }
      else {
        fetchDeviceListResponseHelper(response);
      }
    } catch (err) {
      console.error("Error fetching device list:", err);
      setError("Failed to fetch device list. Please try again.");
      setIsLoading(false);
      const errorMsg = err.response?.data ? err.response?.data?.message : err.message;
      if (typeof onError === "function") {
        onError(errorMsg);
      }
    }
  };

  const handleReplaceHomeRouter = async () => {
    if (!homeRouter) {
      onError('No Home Router');
    } else {
      updateDeviceList(homeRouter.device_id, {
        ...homeRouter,
        mac: deviceMac,
      })
        .then((res) => {
          onSuccess(null);
        })
        .catch((err) => {
          const errorMsg = err.response?.data ? err.response?.data?.message : err.message;
          if (err?.response?.status === 409 && err.response.data.code === 100) {
            setRouterError("You'll need to reboot the router first after ten minutes. After the reboot, you'll be able to get online and you'll be ready to experience life in the fast lane.");
          } else {
            onError(errorMsg || "There was a problem");
          }
        });
    }
  };

  useEffect(() => {
    fetchDeviceList();
  }, [loginData, onError, updateResponse]);

  const handleDeviceSelect = async (device) => {
    setSelectedDevice(device);
    if (!macAddress) {
      console.error("MAC address is missing");
      if (typeof onError === "function") {
        onError("MAC address is missing. Please try again or contact support.");
      }
      return;
    }

    //always use mac address from query params to update
    let deviceMac = {
      mac: macAddress,
    };

    try {
      const response = await updateDeviceList(device.device_id, deviceMac);
      if (response.status === 200) {
        console.log("Device updated successfully");
        setShowGetUserOnline(true);
      } else {
        console.error("Failed to update device");
        if (typeof onError === "function") {
          onError("Failed to update device. Please try again.");
        }
      }
    } catch (err) {
      console.error("Error updating device:", err);
      if (typeof onError === "function") {
        const errorMsg = err.response?.data ? err.response?.data?.message : err.message;
        onError(errorMsg);
      }
    }
  };

  const handleDeviceAdd = async (newDevice) => {
    try {
      if (!newDevice.mac) {
        throw new Error("MAC address needs to be defined");
      }
      //
      const response = await addDeviceList(newDevice);
      if (response.status === 201) {
        console.log("Device added successfully");
        setShowGetUserOnline(true);
        //await fetchDeviceList();
      } else {
        console.error("Failed to add device");
        if (typeof onError === "function") {
          onError("Failed to add device. Please try again.");
        }
      }
    } catch (err) {
      console.error("Error adding device:", err);
      if (typeof onError === "function") {
        const errorMsg = err.response?.data ? err.response?.data?.message : err.message;
        onError(errorMsg);
      }
    }
  };

  const handleGetUserOnlineSuccess = (data) => {
    onSuccess({ ...loginData, selectedDevice: selectedDevice, ...data });
  };

  const handleGetUserOnlineError = (error) => {
    if (typeof onError === "function") {
      onError(error);
    }
  };

  const handleConfirmUserChoice = (userChoice) => {
    setShowHomeRouterModal(false);
    setIsLoading(false);
    
    if (userChoice === 'no' && deviceListResponseData?.data?.current_device_limit - deviceList.length > 0) {
      setShowDeviceModelSelector(false);
      onError("We're not quite ready to offer that service. Please reconnect your previous router to continue.");
    } 
    else if (userChoice !== "no") {
      closeModal();
      setShowDeviceIDFlow(false);
      setShowDeviceModelSelector(false);
    }
  };


  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }

  if (showUpdate){
    return <UpgradeModal finishLogin={handleFinishLogin} handleUpdateCustomer={handleUpdateCustomer} />;
  }

  if (showSelfcare){
    return <GoToSelfcare finishLogin={handleFinishLogin} />
  }

  if (showUpdateResponse){
    return <UpdateResponseModal handleUpdateSuccessContinueLoginFlow={handleUpdateSuccessContinueLoginFlow}/>
  }

  if (showGetUserOnline) {
    return (
      <GetUserOnline
        customerDataObj={loginData}
        onSuccess={handleGetUserOnlineSuccess}
        onError={handleGetUserOnlineError}
      />
    );
  }

  if (showDeviceModelSelector) {
    return <DeviceModelSelector onDeviceAdd={handleDeviceAdd} />;
  }

  if (showHomeRouterModal) {
    return <HomeRouterModal 
      open={showHomeRouterModal} 
      onClose={handleConfirmUserChoice} 
      onReplaceHomeRouter={handleReplaceHomeRouter}
      error={routerError}
    />
  }

  return (
    <Box>
      <Typography variant="h6" sx={{ mb: 2, lineHeight: 1 }}>
        {modalText}
      </Typography>
      <List>
        {deviceList.map((device) => (
          <ListItem
            key={device.id || device.name}
            onClick={() => handleDeviceSelect(device)}
            sx={{
              cursor: "pointer",
              border: "1px solid #ccc",
              borderRadius: "4px",
              padding: "7px 10px",
              margin: "8px 0",
              "&:hover": {
                backgroundColor: "#f0f0f0",
              },
              display: "flex",
              alignItems: "center",
            }}
          >
            <Box sx={{ mr: 1 }}>
              <Box className={`deviceModel ${device.model}`}></Box>
            </Box>
            <Box sx={{ display: "flex", flexDirection: "column" }}>
              <Typography variant="body1" sx={{ fontFamily: "Figtree-Bold" }}>
                {device.name || `Device ${device.id}`}
              </Typography>
              <Typography variant="body2" sx={{ color: "#ccc" }}>
                {device.mac}
              </Typography>
            </Box>
          </ListItem>
        ))}
      </List>
      <Typography
        onClick={onClose}
        variant="body2"
        sx={{ textDecoration: "underline", cursor: "pointer" }}
      >
        Cancel
      </Typography>
    </Box>
  );
};
